import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { ObserveJobOffersByOwnerIdAndOrganizationModuleIdQuery } from 'application/job/query/observe-job-offers-by-owner-id-and-organization-module-id.query';
import { environment } from 'environments/environment';
import { ApiAdapter } from 'infrastructure/common/api.adpater';
import { CreateJobOfferApiMutation } from 'infrastructure/graphql/iam/job/mutation/create-job-offer.mutation';
import { FetchJobOffersByOwnerIdAndOrganizationModuleIdApiQuery } from 'infrastructure/graphql/iam/job/query/fetch-job-offers-by-ownerId-and-organization-module-id-api.query';
import { MoveJobOfferToColumnCmd } from 'job/command/move-job-offer-to-column.cmd';
import { SaveJobOfferCmd } from 'job/command/save-job-offer.cmd';
import { UpdateJobOfferDocumentCmd } from 'job/command/update-job-offer-document.cmd';
import { JobOfferDocumentOutput } from 'job/model/job-offer-document.output';
import { JobOfferOutput } from 'job/model/job-offer.output';
import { MoveJobOfferToColumnApiMutation } from 'job/mutation/move-job-offer-to-column.mutation';
import { UpdateJobOfferDocumentApiMutation } from 'job/mutation/update-job-offer-document.mutation';
import { UpdateJobOfferApiMutation } from 'job/mutation/update-job-offer.mutation';
import { JobOfferApiPort } from 'job/port/job-offer-api.port';
import { FetchJobOfferByIdApiQuery } from 'job/query/fetch-job-offer-by-id.query';
import { FetchJobOffersByIdsApiQuery } from 'job/query/fetch-job-offers-by-ids.query';
import { UserSessionPort } from 'user/port/user-session.port';

@Injectable()
export class JobOfferApiAdapter extends ApiAdapter implements JobOfferApiPort {
	constructor(
		userSessionPort: UserSessionPort,
		translateService: TranslateService,
		private _httpClient: HttpClient,
		private _createJobOfferApiMutation: CreateJobOfferApiMutation,
		private _fetchJobOfferByIdApiQuery: FetchJobOfferByIdApiQuery,
		private _updateJobOfferApiMutation: UpdateJobOfferApiMutation,
		private _fetchJobOffersByIdsApiQuery: FetchJobOffersByIdsApiQuery,
		private _moveJobOfferToColumnApiMutation: MoveJobOfferToColumnApiMutation,
		private _updateJobOfferDocumentApiMutation: UpdateJobOfferDocumentApiMutation,
		private _fetchJobOffersByOwnerIdAndOrganizationModuleIdApiQuery: FetchJobOffersByOwnerIdAndOrganizationModuleIdApiQuery
	) {
		super(userSessionPort, translateService);
	}

	public updateJobOfferDocument(
		cmd: UpdateJobOfferDocumentCmd
	): Observable<JobOfferOutput> {
		return this.mutate$(this._updateJobOfferDocumentApiMutation, cmd);
	}

	public moveJobOfferToColumn(
		cmd: MoveJobOfferToColumnCmd
	): Observable<JobOfferOutput> {
		return this.mutate$(this._moveJobOfferToColumnApiMutation, cmd);
	}

	public generateModuleDocumentUrl(
		file: File
	): Observable<JobOfferDocumentOutput> {
		const apiUrl = `${environment.iamRestApiBaseUrl}/jobOffers/document`;

		const formData = new FormData();
		formData.append('upload', file, file.name);

		return this._httpClient.post<JobOfferDocumentOutput>(apiUrl, formData);
	}

	public createJobOffer(cmd: SaveJobOfferCmd): Observable<JobOfferOutput> {
		return this.mutate$(this._createJobOfferApiMutation, {
			organizationModuleId: cmd.organizationModuleId,
			moduleColumnId: cmd.moduleColumnId,
			contractType: cmd.contractType,
			companyName: cmd.companyName,
			keyPoints: cmd.keyPoints,
			ownerId: cmd.ownerId,
			title: cmd.title,
		});
	}

	public updateJobOffer(cmd: SaveJobOfferCmd): Observable<JobOfferOutput> {
		return this.mutate$(this._updateJobOfferApiMutation, {
			contractType: cmd.contractType,
			companyName: cmd.companyName,
			keyPoints: cmd.keyPoints,
			id: cmd.jobOfferId,
			title: cmd.title,
		});
	}

	public fetchJobOfferById(id: string): Observable<JobOfferOutput> {
		return this.fetch$(this._fetchJobOfferByIdApiQuery, {
			id,
		});
	}

	public fetchJobOffersByIds(ids: string[]): Observable<JobOfferOutput[]> {
		return this.fetch$(this._fetchJobOffersByIdsApiQuery, {
			ids,
		});
	}

	public fetchJobOffersByOwnerIdAndOrganizationModuleId(
		query: ObserveJobOffersByOwnerIdAndOrganizationModuleIdQuery
	): Observable<JobOfferOutput[]> {
		return this.fetch$(
			this._fetchJobOffersByOwnerIdAndOrganizationModuleIdApiQuery,
			query
		);
	}
}
